export const deleteIcon = require('./delete.svg');
export const edit = require('./edit.svg');
export const visa = require('./visa-color.svg')
export const mastercard = require('./mastercard-color.svg')
export const upload = require('./upload.svg');